import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-screen items-center justify-center p-6 text-center" }
const _hoisted_2 = { class: "text-gray-600" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-2xl font-semibold mb-2" }, "Redirecting…", -1)),
      _createElementVNode("p", _hoisted_2, [
        _cache[0] || (_cache[0] = _createTextVNode("If nothing happens, ")),
        _createElementVNode("a", {
          href: _ctx.fallbackUrl,
          class: "text-blue-600 underline"
        }, "click here", 8, _hoisted_3),
        _cache[1] || (_cache[1] = _createTextVNode("."))
      ])
    ])
  ]))
}